Router = App.loadClass 'core::Router'
WeightingsHandler = App.loadClass 'portal::handlers/weightings/Sidebar'

class exports.WeightingsRouter extends Router

    prefix: 'Weightings'
    module_name: 'WeightingsRouter'

    register: () ->
        @module = angular.module @module_name, ['ui.router', 'ui.bootstrap']

    registerRoutes: ($stateProvider) ->
        $stateProvider
            .state 'portal.weightings',
                url: '/weightings'
                template: '<div></div>'
                controller: ['$scope', ($scope) ->
                    App.current_page = new WeightingsHandler()
                    App.sidebar?.open?()
                    App.current_page.init()
                ]
